<template>
    <div class="page-container">
        <van-nav-bar left-arrow fixed :z-index="10" @click-left="goPrev" title="合格投资者承诺函"></van-nav-bar>
        <h2 class="ta-c">
            合格投资者承诺函
        </h2>
        <div class="content">
            <div>本投资人（下称“本人”）郑重承诺如下：</div>
            <div>一、本人具有相应合法的投资主体资格，不存在任何法律、行政法规、中国证券监督管理委员会等规范性文件及交易规则禁止或限制的情形。</div>
            <div>二、本人提供的所有证件、资料均真实、全面、有效、合法，并且保证资金来源合法。</div>
            <div>三、本人已充分了解下述关于合格投资者的规定，并承诺本人是符合该规定的合格投资者。</div>
            <div>四、本人具备较强风险承受能力，近三年年收入不少于40万元且本人个人或家庭金融资产总计在本人受让金融资产时不低于300万元人民币。</div>
            <div>五、本人还满足以下条件：</div>
            <div>（一）具备法律规定的完全行为能力的中国境内的自然人；</div>
            <div>（二）具备与投资金融资产相匹配的风险承受能力。</div>
            <div>前款所称金融资产包括银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等。</div>
            <div class="ta-l mt-30">本人继续相关业务操作及实际支付相关交易款项，即表明本人符合天安金交中心关于合格投资者规定的合格投资者身份并愿意承担因虚假承诺带来的任何风险。</div>
            <!-- <div class="ta-r mt-30">本人继续相关业务操作及实际支付相关交易款项，即表明本人符合天安金交中心关于合格投资者规定的合格投资者身份并愿意承担因虚假承诺带来的任何风险。</div> -->
        </div>
    </div>
</template>

<script>
    import { NavBar } from "vant";
    export default {
        name: "relief",
        components:{
            [NavBar.name]:NavBar
        },

        methods : {
            goPrev(){
                this.goableBack();
            }
        },
    }
</script>

<style lang="less" scoped>
    .page-container {
        line-height: 2;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 20px;
    }
    p {
        text-indent: 20px;
    }
    h3 {
        text-align: center;
    }
    .content > div >b:first-child {
        margin-right: 14px;
    }
    .van-nav-bar {
        background: #fff;

        .van-nav-bar__title {
            color: @dark;
        }
        .van-icon {
            color: @dark !important;
        }
    }
</style>